<template>
    <v-card tile>
        <v-card-title class="subtitle-1 font-weight-bold px-6">
            {{ translations.modalTitle[lang] }}
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('cancel')">
                <v-icon v-text="icons.mdiClose"></v-icon>
            </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-4 pb-1">
            <v-toolbar flat height="90">
                <v-col cols="12" sm="6">
                    <b-search-field v-model="search"></b-search-field>
                </v-col>
            </v-toolbar>
            <v-data-table
                :headers="headers"
                :items="redeemedCouponAndVoucherCodesData"
                :footer-props="{
                    itemsPerPageOptions: [12],
                    showCurrentPage: true,
                    pageText: `${page * 12 - 11}-${
                        page * 12 <= itemsLength ? page * 12 : itemsLength
                    } ${translations.paginationText[lang]} ${itemsLength}`,
                }"
                :page.sync="page"
                :loading="loading"
                :server-items-length="itemsLength"
                :options.sync="options"
                class="b-outlined"
            ></v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import { mdiClose } from "@mdi/js";

import translations from "@/utils/translations/storePanel/couponsOverview";
import { mapActions, mapState } from "vuex";
import debounce from "lodash/debounce";

export default {
    name: "AdditionalInfo",

    mixins: [translations],

    props: {
        couponId: Number,
    },

    data: () => ({
        icons: { mdiClose },
        page: 1,
        search: "",
        options: {},
        order: null,
    }),

    computed: {
        ...mapState(["loading", "serverItemsLength"]),

        ...mapState("storePanel/couponsOverview", [
            "redeemedCouponAndVoucherCodesData",
            "itemsLength",
        ]),

        lang() {
            return this.$route.params.lang;
        },

        headers() {
            return [
                {
                    text: this.translations.mobile[this.lang],
                    value: "mobile",
                },
                {
                    text: this.translations.voucherOrCouponCode[this.lang],
                    value: "voucher",
                },
                {
                    text: this.translations.redemptionTimestamp[this.lang],
                    value: "redeemed_at",
                },
            ];
        },
    },

    methods: {
        ...mapActions("storePanel/couponsOverview", [
            "getRedeemedCouponAndVoucherCodes",
        ]),

        handleSearch() {
            this.getRedeemedCouponAndVoucherCodes({
                coupon_id: this.couponId,
                page: 1,
                search: this.search,
                order: this.order,
            });
        },
    },

    watch: {
        couponId(val) {
            this.page = 1;
            this.getRedeemedCouponAndVoucherCodes({
                coupon_id: val,
                page: this.page,
                search: this.search,
                order: this.order,
            });
        },

        page(val) {
            this.getRedeemedCouponAndVoucherCodes({
                coupon_id: this.couponId,
                page: val,
                search: this.search,
                order: this.order,
            });
        },

        search(val) {
            if (val == null) {
                this.getRedeemedCouponAndVoucherCodes({
                    coupon_id: this.couponId,
                    page: 1,
                    search: this.search,
                    order: this.order,
                });
            } else {
                this.debouncedSearch();
            }
        },

        options: {
            handler(val) {
                if (val.sortBy[0]) {
                    this.order = val.sortBy[0].split("[")[0];

                    if (val.sortDesc) {
                        this.order += "," + (val.sortDesc[0] ? "desc" : "asc");
                    }

                    this.getRedeemedCouponAndVoucherCodes({
                        coupon_id: this.couponId,
                        page: this.page,
                        search: this.search,
                        order: this.order,
                    });
                }
            },
            deep: true,
        },
    },

    mounted() {
        this.getRedeemedCouponAndVoucherCodes({
            coupon_id: this.couponId,
            page: this.page,
            search: this.search,
            order: this.order,
        });
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
    },
};
</script>
